import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const StyledFieldset = /*#__PURE__*/styled('fieldset').withConfig({
  componentId: "sc-storm-ui-30054544__sc-3cfjbz-0"
})(["border:none;margin:0;padding:0;"]);
const RadioButtonContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-3cfjbz-1"
})(["display:flex;flex-direction:", ";", ""], ({
  inline
}) => inline ? 'row' : 'column', isMobile(css(["background-color:", ";border:1px solid ", ";border-radius:", ";flex-direction:column;"], ({
  theme
}) => theme.form.radio.mobile.groupBackgroundColor, ({
  theme
}) => theme.form.radio.mobile.groupBorderColor, ({
  theme
}) => theme.form.radio.mobile.groupBorderRadius)));
RadioButtonContainer.displayName = 'RadioButtonContainer';
const StyledLegend = /*#__PURE__*/styled('legend').withConfig({
  componentId: "sc-storm-ui-30054544__sc-3cfjbz-2"
})(["", ";margin-bottom:", ";font-weight:", ";padding:0;margin-inline-end:", ";", " ", " ", " display:block;box-sizing:border-box;"], ({
  theme
}) => theme.typography.base, ({
  inlineLabel,
  theme
}) => !inlineLabel ? theme.spacing.micro : 0, ({
  theme
}) => theme.form.label.weight, ({
  inline,
  inlineLabel,
  theme
}) => {
  if (inline) {
    return theme.spacing.base;
  }
  if (inlineLabel) {
    return theme.spacing.mini;
  }
  return 0;
}, ({
  hidden
}) => hidden && `
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    width: 1px;
  `, ({
  disabled
}) => disabled && css(["cursor:not-allowed;outline:none;color:", ";"], ({
  theme
}) => theme.form.label.colorDisabled), isMobile(css(["", ";margin-bottom:", ";"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.spacing.micro)));
StyledLegend.displayName = 'StyledLegend';
const RadioGroupContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-3cfjbz-3"
})(["", " ", ""], ({
  inline,
  inlineLabel
}) => inlineLabel && `
    align-items: ${inline ? 'center' : 'flex-start'};
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  `, isMobile(css(["", ""], ({
  inlineLabel
}) => inlineLabel && `
      align-items: stretch;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    `)));
RadioGroupContainer.displayName = 'RadioGroupContainer';
const RadioButtonGroup = ({
  children,
  inline,
  inlineLabel,
  label,
  disabled,
  hideLabel,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('radio-button-group')
}, /*#__PURE__*/React__default.createElement(StyledFieldset, rest, /*#__PURE__*/React__default.createElement(RadioGroupContainer, {
  inline: inline,
  inlineLabel: inlineLabel
}, label !== undefined ? /*#__PURE__*/React__default.createElement(StyledLegend, {
  disabled: disabled,
  hidden: hideLabel,
  inline: inline,
  inlineLabel: inlineLabel
}, label) : null, /*#__PURE__*/React__default.createElement(RadioButtonContainer, {
  inline: inline
}, children))));
RadioButtonGroup.defaultProps = {
  hideLabel: false,
  inlineLabel: false,
  label: undefined,
  inline: false,
  disabled: false
};

export { RadioButtonGroup as R, RadioButtonContainer as a };
//# sourceMappingURL=RadioButtonGroup-0mzZU-bn.js.map
